export default __webpack_public_path__ + "static/media/DinosaursArmoredReptiles_07.cf899386.png";